export default __webpack_public_path__ + "static/media/LinkWentworth.166f2743.jpeg";